module.exports = __webpack_public_path__ + "img/lock.a29e4dee.svg";